<template>
  <div class="device-table-wrapp">
    <vue-custom-scrollbar class="device-table scroll-without-bg scroll-small-size"  :settings="settings">
      <table class="device-table">
        <tr>
          <th v-on:click="sortDate()" v-bind:class="{active :(sort.date === SORT_ASC), sort}"><span>{{deviceTableName.date}}</span></th>
          <th v-for="(nameField, index) in nameFields" :key="index"><span>{{nameField}}</span></th>
        </tr>
        <tr v-for="value in tableData" :key="value.time">
          <td><span>{{value.time}}</span><b></b><i>{{value.time}}</i></td>
          <td v-for="(cell, index) in value.cells" :key="index"><span>{{cell}}</span><b></b><i>{{cell}}</i></td>
        </tr>
      </table>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
import moment from 'moment'
import collection from 'lodash/collection'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import '../../assets/css/custom-scrollbar.scss'

const SORT_ASC = 'asc'
const SORT_DESC = 'desc'
const SORT_UNSORTED = 'unsorted'
export default {
  name: 'DeviceTable',
  components: {
    vueCustomScrollbar
  },
  props: {
    params: Array,
    values: Object
  },
  data () {
    return {
      settings: {
        wheelPropagation: true,
        swicher: true,
        wheelSpeed: 0.4
      },
      SORT_ASC: SORT_ASC,
      SORT_DESC: SORT_DESC,
      SORT_UNSORTED: SORT_UNSORTED,

      deviceTableName: {
        date: 'Дата'
      },
      deviceTables: [
      ],
      tableData: [],
      sort: {
        date: SORT_UNSORTED
      }
    }
  },
  methods: {
    sortTable (sortStatus, fieldName) {
      if ((sortStatus === SORT_UNSORTED) || (sortStatus === SORT_DESC)) {
        this.deviceTables = collection.orderBy(this.deviceTables, [fieldName], ['asc'])
        return SORT_ASC
      } else {
        this.deviceTables = collection.orderBy(this.deviceTables, [fieldName], ['desc'])
        return SORT_DESC
      }
    },
    sortDate () {
      this.sort.date = this.sortTable(this.sort.date, 'date')
    },
    formatDate (timestamp) {
      return moment((timestamp - 1000 * 60 * 60 * 2)).format('DD/MM/YYYY HH') + ':00'
    },
    aggregate () {
      let results = []

      this.params.forEach(val => {
        if (this.values.hasOwnProperty(val.key)) {
          let min = null; let max = null; let sum = null; let total = 0; let time = null; let result = []
          let batchTime = null
          this.values[val.key].forEach(data => {
            time = this.formatDate(data[0])
            total++

            if (batchTime === null) {
              batchTime = time
              min = data[1]
              max = data[1]
              sum = 0
            }

            if (batchTime !== time) {
              result.push({
                time: batchTime,
                min: min,
                max: max,
                avg: Math.round(sum / total * 100) / 100
              })

              min = data[1]
              max = data[1]
              sum = 0
              batchTime = time
              total = 1
            }

            if ((data[1] !== null) && (data[1] > max)) {
              max = data[1]
            }

            if ((data[1] !== null) && (data[1] < min)) {
              min = data[1]
            }

            sum += data[1]
          })

          result.push({
            time: batchTime,
            min: min,
            max: max,
            avg: Math.round(sum / total * 100) / 100
          })

          results.push({
            key: val.key,
            data: result
          })
        }
      })

      results[0].data.forEach((item, idx) => {
        let value = {
          time: item.time,
          cells: []
        }
        results.forEach(r => {
          value.cells.push(r.data[idx].min)
          value.cells.push(r.data[idx].max)
          value.cells.push(r.data[idx].avg)
        })
        this.tableData.push(value)
      })
    }
  },
  computed: {
    nameFields () {
      return collection.flatMap(this.params, function (param) {
        return [param.title + ' min', param.title + ' max', param.title + ' avg']
      })
    }
  },
  mounted () {
    this.aggregate()
  }
}
</script>
